var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-card',{attrs:{"max-width":_vm.maxWidth}},[_c('m-card-title',[_vm._v(_vm._s(_vm.title))]),_c('hr'),_c('SingleBarChartSimple',{attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }